import React from "react";
import {
	  AppBar,
	  Toolbar,
	  Typography,
	  Button,
	  Box,
	  Container
} from "@mui/material";

const Header = ({ logout, goHome }) => {
	  return (
		      <AppBar position="static" color="primary" elevation={2}>
		        <Container maxWidth="lg">
		          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
		            <Typography
		              variant="h6"
		              component="div"
		              sx={{ flexGrow: 1, mr: 2 }}
		            >
		              Prototype of DCTS:
		            </Typography>
		            <Box sx={{ flexGrow: 1 }}>
		              <Typography variant="body2">
		                Dementia Caregivers Training Simulation
		              </Typography>
		            </Box>
		            <Box>
		              <Button color="inherit" onClick={goHome} sx={{ mr: 1 }}>
		                Home
		              </Button>
		              <Button color="inherit" onClick={logout}>
		                Logout
		              </Button>
		            </Box>
		          </Toolbar>
		        </Container>
		      </AppBar>
		    );
};

export default Header;

